


export const GET_REQUEST = "GET_REQUEST"

export const GET_SUCCESS = "GET_SUCCESS"

export const GET_FAILURE = "GET_FAILURE"
